<template>
    <div class="container col-vis-form">

        <div class="row">
            <h1>
                <i class="fas fa-eye"></i>
                Visible Columns
            </h1>
        </div>

        <div class="row">
            <ul class="col-vis-wrap">
                <li v-for="col in all_columns" class="col-vis-item">
                    <p-check
                            :name="col"
                            color="success-o"
                            :value="col"
                            @change="checkboxChanged(col, $event)"
                            :checked="isOriginallySelected(col)"
                            :key="col">
                        {{ col }}
                    </p-check>
                </li>
            </ul>
        </div>

        <div class="row col-vis-buttons">
            <button class="btn btn-col-vis-close" @click="closeModal">
                <i class="fas fa-times"></i>
                Cancel
            </button>
            <button class="btn btn-col-vis-create" @click="save">
                <i class="fas fa-plus"></i>
                Save
            </button>
        </div>

    </div>
</template>

<script>

    var Vue = window.Vue;

    import * as _ from "lodash";
    // import 'pretty-checkbox/src/pretty-checkbox.scss';
    // import PrettyCheckbox from 'pretty-checkbox-vue';
    // Vue.use(PrettyCheckbox);

    export default {

        props: {
            all_columns: {
                type: Array,
                required: true,
            },
            selected_columns: {
                type: Array,
                required: true,
            },
        },

        data: () => ({
            columns: [],
            selected: [],
        }),

        //components: { PrettyCheckbox },

        mounted() {
            // Copy the props by value (not ref) to data
            this.columns = this.all_columns.slice();
            this.selected = this.selected_columns.slice();
        },

        methods: {
            isOriginallySelected(col) {
                return _.indexOf(this.selected_columns, col) !== -1;
            },
            checkboxChanged(col, checked) {
                let inArray = _.indexOf(this.selected, col) !== -1;
                if (inArray && checked)
                    return;

                if (checked)
                    this.selected.push(col);
                else
                    this.selected = _.remove(this.selected, selected => selected !== col);
            },
            save() {
                this.$emit('selected-columns', this.selected);
                this.closeModal();
            },
            closeModal() {
                this.$emit('close');
            },
        },

    }
</script>

<style>

    .col-vis-wrap {
        display: flex;
        flex-flow: column-reverse wrap;
        justify-content: flex-end;
        align-items: flex-start;
        max-height: 500px;
    }
    .col-vis-item {
        width: 45%;
        padding: 6px 0;
        list-style: none;
    }
    .col-vis-item label {
        font-size: 20px;
        padding-left: 15px;
    }

    .col-vis-form {
        width: 100%;
    }

    .col-vis-form .row {
        padding: 10px 0;
    }

    .col-vis-form h1 .fas,
    .col-vis-buttons .btn .fas {
        margin-right: 10px;
    }

    .col-vis-buttons {
        text-align: center;
        margin: 15px 0;
    }

    .col-vis-buttons .btn {
        margin: 25px;
        color: #fff;
        font-weight: bold;
        padding: 8px 20px;
        font-size: 22px;
    }

    .btn-col-vis-create {
        background-color: #289b29;
    }

    .btn-col-vis-close {
        background-color: #7b7b7b;
    }

    .col-vis-form .btn[disabled],
    .col-vis-form fieldset[disabled] .btn {
        opacity: 0.5 !important;
    }

    .col-vis-form h2 {
        font-size: 17px;
        font-weight: bold;
        color: #666;
    }

    .col-vis-field-required::after {
        content: '*';
        color: #6d0000;
        font-weight: bold;
        top: 0;
        right: -10px;
        position: relative;
    }

    .col-vis-form input[type="text"] {
        width: 100%;
        border: 1px solid rgba(60,60,60,.26);
        border-radius: 4px;
        color: #333;
        line-height: 1.4;
        margin: 4px 2px 0;
        padding: 10px 16px;
    }

</style>
